import { render, staticRenderFns } from "./ModalImgUpload.vue?vue&type=template&id=c6a5597a&scoped=true&"
import script from "./ModalImgUpload.vue?vue&type=script&lang=js&"
export * from "./ModalImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./ModalImgUpload.vue?vue&type=style&index=0&id=c6a5597a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a5597a",
  null
  
)

/* custom blocks */
import block0 from "./ModalImgUpload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports